import React from 'react';
import { ITab } from '../../Assets/AssetsEdit';
import { CustomerProjectsHistory } from '../CustomerProjectsHistory';

interface Props extends ITab {
  id: string;
  historyItems: any;
}
export const CustomerProjectsHistoryTab = ({ id, active, historyItems }: Props) => {
  return <CustomerProjectsHistory historyItems={historyItems} />;
};
